<div mat-dialog-content>
    <div class="row-form">
        <h2 class="text-center">Editar cadastro</h2>
    </div>
    <div class="row-form">
        <mat-form-field>
            <mat-label>NOME FANTASIA</mat-label>
            <input matInput class="input-text" [(ngModel)]="dealer.name"/>
        </mat-form-field>
    </div>

    <div class="row-form">
        <mat-form-field>
            <mat-label>CEP</mat-label>
            <input matInput mask="00000-000" [dropSpecialCharacters]="false" (change)="getCEP()" [(ngModel)]="dealer.zipCode"/>
        </mat-form-field>
    </div>
    <div class="row-form">
        <mat-form-field>
            <mat-label>Endereço</mat-label>
            <input matInput [(ngModel)]="dealer.address"/>
        </mat-form-field>
    </div>

    <div class="row-form">
        <mat-form-field>
            <mat-label>NÚMERO</mat-label>
            <input matInput [(ngModel)]="dealer.addressNumber"/>
        </mat-form-field>
    </div>

    <div class="row-form">
        <mat-form-field>
            <mat-label>COMPLEMENTO</mat-label>
            <input matInput [(ngModel)]="dealer.addressComplement"/>
        </mat-form-field>
    </div>

    <div class="row-form">
        <mat-form-field>
            <mat-label>Bairro</mat-label>
            <input matInput  [(ngModel)]="dealer.district"/>
        </mat-form-field>
    </div>

    <div class="row-form">
        <mat-form-field>
            <mat-label>CIDADE</mat-label>
            <input matInput [matAutocomplete]="cityAutoComplete" [(ngModel)]="dealer.cityName"/>

            <mat-autocomplete #cityAutoComplete="matAutocomplete" (optionSelected)="selectCity($event.option.value)">
                <mat-option *ngFor="let option of cityOptions | async" [value]="option">
                    {{ option.name }} - {{ option.uf }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>

    <div class="row-form" >
        <mat-form-field>
            <mat-label>Estado civil</mat-label>

            <mat-select aria-label="Select an option" [(ngModel)]="dealer.maritalStatus">
                <div *ngFor="let item of maritalStatuses">
                    <mat-option [value]="item">{{ getMaritalStatus(item) }}</mat-option>
                </div>
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row-form">
        <mat-form-field>
            <mat-label>Telefone</mat-label>
            <input matInput mask="(00) 00000-0000" [dropSpecialCharacters]="false" [(ngModel)]="phoneNumber" (keydown.enter)="addPhone()" />
            <span matSuffix>
                <span (click)="addPhone()" class="material-icons pointer-hover color-topaz">add</span>
            </span>
        </mat-form-field>
    </div>
    <div class="d-flex row-form flex-wrap">
        <a (click)="removePhone(index)" *ngFor="let phone of dealer.phoneNumbers; let index = index"
            class="btn btn-primary btn-outline-admin pointer-hover p-1 mr-1 mb-2">
            {{ phone }} <span class="material-icons">close</span>
        </a>
    </div>


    <div class="row-form">
        <mat-form-field>
            <mat-label>Whatsapp</mat-label>
            <input matInput mask="(00) 00000-0000" [dropSpecialCharacters]="false" [(ngModel)]="dealer.whatsappNumber" />
        </mat-form-field>
    </div>

    <div class="col d-flex flex-row-reverse align-content-end">
        <div class="align-self-end">
          <button class="btn btn-pill btn-primary btn-save-text" (click)="saveDealer()">
            <span class="material-icons btn-save-icon"> done </span>
            Salvar
          </button>
        </div>
      </div>
</div>